import React from 'react';
import Modal from './Modal';
import Button from './Button';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmVariant?: 'primary' | 'danger' | 'warning' | 'success';
  onConfirm: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'primary',
  onConfirm,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };
  
  // Map 'warning' and 'success' to available button variants
  const buttonVariant = confirmVariant === 'warning' || confirmVariant === 'success' 
    ? 'primary' 
    : confirmVariant;
  
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <div className="p-4">
        <p className="text-gray-600">{message}</p>
      </div>
      
      <div className="flex justify-end gap-3 px-4 py-3 bg-gray-50 border-t border-gray-200">
        <Button variant="secondary" onClick={onClose}>
          {cancelText}
        </Button>
        <Button variant={buttonVariant} onClick={handleConfirm}>
          {confirmText}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal; 